import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../config/AuthContext";
import Login from "../../Login";
import { Content } from "antd/es/layout/layout";
import { Button, Progress, Table, TableProps, Tag, Modal as AntModal, Select, Spin, Card, Typography, Space, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import AvaluacioColors from "../../../styles/AvaluacioColors";
import { BiArrowFromLeft, BiCopy, BiPencil, BiPlus, BiRefresh, BiShow, BiSolidFilePdf, BiSolidGraduation } from "react-icons/bi";
import ProjecteDuplicarModal from "./ProjecteDuplicarModal";
import AppSider from "../../avaluacio/components/AppSider";
import { GetPercentatges } from "../../../dao/abp/GetPercentatges";
import { GetAlumnesPercentatges } from "../../../dao/abp/GetAlumnesPercentatges";
import { GetAlumneNotes } from "../../../dao/abp/GetAlumneNotes";
import { red, yellow } from '@ant-design/colors';
import ProjecteModal from "./ProjecteModal";
import { GetProjectes } from "../../../dao/abp/GetProjectes";
import { GetProjecteIdInforme } from "../../../dao/abp/GetProjecteIdInforme";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import ProjecteIdTasques from "../projecteIdGrupIdAvaluacio/content/ProjecteIdTasques";
import { GetProjecteId } from "../../../dao/abp/GetProjecteId";
import { GetProjecteImagen } from "../../../dao/GetProjecteImagen";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);

const TIMEZONE = "Europe/Madrid";



interface ProjecteImagenProps {
    id: number;
}

const ProjecteImagen: React.FC<ProjecteImagenProps> = ({ id }) => {
    const [base64, setBase64] = useState<string | null>(null);

    useEffect(() => {
        let mounted = true;

        GetProjecteImagen(id + "")
            .then((res: any) => {
                if (mounted && res?.json) {
                    const cleaned = res.json.split(':').pop();
                    setBase64(cleaned);
                }
            })
            .catch(() => {
                if (mounted) setBase64(null);
            });

        return () => { mounted = false; };
    }, [id]);

    if (!base64) return <div style={{ width: 50, height: 50, background: '#eee', borderRadius: 12 }} />;

    return (
        <img
            src={`data:image/png;base64,${base64}`}
            alt="project"
            style={{
                width: 50,
                height: 50,
                objectFit: 'cover',
                borderRadius: 12,
                boxShadow: '0 1px 4px rgba(0,0,0,0.1)'
            }}
        />
    );
};


const Projectes = () => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const navigate = useNavigate();
    const [dades, setDades] = useState<any[]>([]);
    const [filteredEstat, setFilteredEstat] = useState<any[]>((user?.tipus === "1" || user?.tipus === "0") ? [0, 1] : [1]);
    const [pantalla, setPantalla] = useState(0);
    const [loading, setLoading] = useState(false);
    const [percentatges, setPercentatges] = useState<any[]>([]);
    const [notes, setNotes] = useState<[]>([]);
    const [practices, setPractices] = useState<string[]>([]);
    const [modal, setModal] = useState(false);
    const [selected, setSelected] = useState<any>();
    const [notesModalVisible, setNotesModalVisible] = useState(false);
    const [notesData, setNotesData] = useState<any>(null); // { project: any, group: string }
    const [selectedSprint, setSelectedSprint] = useState<any>(null); // Current selected sprint object
    const [loadingNotes, setLoadingNotes] = useState(false);
    const [duplicarModal, setDuplicarModal] = useState(false);
    const [selectedForDuplicate, setSelectedForDuplicate] = useState<any>(null);

    useEffect(() => {
        if (isLoggedIn) {
            console.log("Projectes - Loading data for user:", userId);
            setBreadCrumb([{ nom: 'Home', nav: '/home' },
            { nom: 'avaluacio', nav: '/abp' },
            { nom: 'projectes', nav: '/abp/projectes' }], true);
            checkDades();
        }
    }, []);

    async function checkDades() {
        setLoading(true); // Mostrar la barra de progreso

        // Ensure userId is valid
        const validUserId = userId && userId.trim() !== "" ? userId : "-1";

        try {
            if (user.tipus === "1") {
                const practices = await GetPercentatges(validUserId);
                console.log("Projectes - Admin/Teacher Practices:", practices);
                if (practices) {
                    setPercentatges(practices);
                    checkPractices(practices);
                } else {
                    setPercentatges([]);
                    checkPractices([]);
                }
            } else if (user.tipus === "0") {
                const practices = await GetProjectes(validUserId);
                console.log("Projectes - SuperAdmin Practices:", practices);
                if (practices && Array.isArray(practices)) {
                    setPercentatges(practices);
                    checkPractices(practices);
                } else {
                    setPercentatges([]);
                    checkPractices([]);
                }
            } else {
                let practices = await GetAlumnesPercentatges(validUserId);
                console.log("Projectes - Alumnes Percentatges:", practices);
                if (practices && Array.isArray(practices)) {
                    // Filter out 'No visible' (estat === 0) for students
                    practices = practices.filter((p: any) => p.percentatge?.estat !== 0);
                    //console.log(">>>>" + JSON.stringify(practices));
                    setPercentatges(practices);
                    checkPractices(practices);
                } else {
                    setPercentatges([]);
                    checkPractices([]);
                }
            }
            // Fix GetAlumneNotes call too
            setNotes(await GetAlumneNotes(validUserId + ""));

        } catch (e) {
            console.error("Error loading data:", e);
            setPercentatges([]);
            checkPractices([]);
        }

        setLoading(false); // Ocultar la barra de progreso cuando los datos se cargan
    }

    function checkPractices(pracs: any[]) {
        if (!pracs || !Array.isArray(pracs)) {
            setPractices([]);
            return;
        }

        // Crear un nuevo conjunto con los valores únicos
        // Use pracs safely
        const uniquePractices = new Set<string>([...practices, ...pracs.map(value => value.nom)]);

        // Convertir el conjunto de nuevo a un array
        const uniquePracticesArray = Array.from(uniquePractices);

        // Actualizar el estado con los valores únicos
        setPractices(uniquePracticesArray);
    }


    function navegar(ele: any) {
        if ((user.tipus === "1" || user.tipus === "0"))
            navigate(`/abp/projectes/${ele.id}`);
        else
            navigate(`/abp/projectes/${ele.id}/grups/${ele.grup}`);
    }

    function editar(ele: any) {
        setLoading(true);
        console.log(ele);
        setSelected(ele);
        setModal(true);
    }

    function duplicar(ele: any) {
        setSelectedForDuplicate(ele);
        setDuplicarModal(true);
    }


    async function download(ele: any) {
        setLoading(true);
        const documentUrl = await GetProjecteIdInforme(ele.id + "");
        console.log("URL: " + documentUrl);
        if (documentUrl) {
            const link = document.createElement('a');
            link.href = documentUrl;
            link.download = `${ele?.nom}.pdf`;
            link.target = '_blank';
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
        setLoading(false);
    }

    async function viewNotes(ele: any) {
        setLoadingNotes(true);
        try {
            // We need id and sprint 0 to get all info including sprints list
            const projectData = await GetProjecteId(ele.id + "", 0);
            if (projectData) {
                // console.log("Project Data Loaded", projectData);
                const firstSprint = projectData.sprints && projectData.sprints.length > 0 ? projectData.sprints[0] : null;
                setNotesData({ project: projectData, group: ele.grup });
                setSelectedSprint(firstSprint);
                setNotesModalVisible(true);
            }
        } catch (e) {
            console.error(e);
        }
        setLoadingNotes(false);
    }

    const { Title, Text } = Typography;

    const columns: ColumnsType<any> = [
        {
            key: 'imagen',
            dataIndex: 'imagen',
            width: 80,
            render: (_imgString: string, ele: any) => {
                return (
                    <div style={{ position: 'relative', width: 50, height: 50 }}>
                        <ProjecteImagen id={ele.id} />
                    </div>
                );
            }
        },
        {
            title: 'Aula',
            key: 'aula',
            dataIndex: 'aula',
            width: 150,
            render: (text: string) => (
                <Space size={[0, 4]} wrap>
                    {text?.split(',').map((aula: string, index: number) => (
                        <Tag 
                            key={index} 
                            color={Object.values(AvaluacioColors.colors)[index % Object.values(AvaluacioColors.colors).length] as string}
                        >
                            {aula.trim()}
                        </Tag>
                    ))}
                </Space>
            )
        },
        {
            title: 'ID',
            key: 'id',
            dataIndex: 'id',
            width: 60,
            responsive: ['lg'],
            render: (text: any) => <Text type="secondary">#{text}</Text>
        },
        {
            title: 'Nom del Projecte',
            key: 'nom',
            dataIndex: 'nom',
            width: 250,
            render: (text) => <Text strong style={{ fontSize: '1.1em' }}>{text}</Text>
        },
        {
            title: 'Progrés',
            key: 'intents_progres',
            dataIndex: 'intents',
            width: 200,
            render: (e, ele) => (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px' }}>
                        <Text type="secondary">Global</Text>
                        <Text type="secondary">100%</Text>
                    </div>
                    <Progress percent={100} steps={10}
                        showInfo={false}
                        strokeWidth={15}
                        strokeColor={[
                            getColor(ele.percentatge.percentP, ele.percentatge.percentA, ele.percentatge.percentNP, 10, AvaluacioColors.colors.color1),
                            getColor(ele.percentatge.percentP, ele.percentatge.percentA, ele.percentatge.percentNP, 20, AvaluacioColors.colors.color1),
                            getColor(ele.percentatge.percentP, ele.percentatge.percentA, ele.percentatge.percentNP, 30, AvaluacioColors.colors.color2),
                            getColor(ele.percentatge.percentP, ele.percentatge.percentA, ele.percentatge.percentNP, 40, AvaluacioColors.colors.color2),
                            getColor(ele.percentatge.percentP, ele.percentatge.percentA, ele.percentatge.percentNP, 50, AvaluacioColors.colors.color3),
                            getColor(ele.percentatge.percentP, ele.percentatge.percentA, ele.percentatge.percentNP, 60, AvaluacioColors.colors.color3),
                            getColor(ele.percentatge.percentP, ele.percentatge.percentA, ele.percentatge.percentNP, 70, AvaluacioColors.colors.color4),
                            getColor(ele.percentatge.percentP, ele.percentatge.percentA, ele.percentatge.percentNP, 80, AvaluacioColors.colors.color4),
                            getColor(ele.percentatge.percentP, ele.percentatge.percentA, ele.percentatge.percentNP, 90, AvaluacioColors.colors.color5),
                            getColor(ele.percentatge.percentP, ele.percentatge.percentA, ele.percentatge.percentNP, 100, AvaluacioColors.colors.color5)
                        ]}
                        trailColor={"#f5f5f5"} type="line"
                    />
                </div>
            )
        },
        {
            title: 'Dates',
            key: 'dates',
            width: 150,
            render: (e, ele) => (
                <Space direction="vertical" size={0}>
                    <Text style={{ fontSize: '13px' }}>Inici: {ele.data_ini ? dayjs(ele.data_ini).format('DD/MM/YYYY') : '-'}</Text>
                    <Text style={{ fontSize: '13px' }} type="secondary">Fi: {ele.data_fi ? dayjs(ele.data_fi).format('DD/MM/YYYY') : '-'}</Text>
                </Space>
            )
        },
        {
            title: 'Estat',
            key: 'estat',
            dataIndex: 'estat',
            width: 120,
            filters: (user.tipus === "1" || user.tipus === "0") ? [
                { text: 'No visible', value: 0 },
                { text: 'En curs', value: 1 },
                { text: 'Finalitzat', value: 2 },
                { text: 'Tancat', value: 3 },
            ] : [
                { text: 'En curs', value: 1 },
                { text: 'Finalitzat', value: 2 },
                { text: 'Tancat', value: 3 },
            ],
            filteredValue: filteredEstat,
            defaultSortOrder: 'descend',
            sorter: (a, b) => b.percentatge?.estat - a.percentatge?.estat,
            onFilter: (value: any, record: any) => record.percentatge?.estat === value,
            render: (e, ele) => {
                const status = ele.percentatge?.estat;
                const configMap = {
                    0: { color: 'default', text: 'No visible' },
                    1: { color: AvaluacioColors.colors.color3, text: 'En curs' },
                    2: { color: AvaluacioColors.colors.color4, text: 'Finalitzat' },
                    3: { color: AvaluacioColors.colors.color1, text: 'Tancat' },
                };
                const statusConfig = configMap[status as keyof typeof configMap] || { color: 'default', text: 'Desconegut' };

                return (
                    <Tag color={statusConfig.color} style={{ borderRadius: 12, padding: '2px 10px' }}>
                        {statusConfig.text}
                    </Tag>
                );
            }
        },
        {
            title: 'Estadístiques',
            key: 'stats',
            width: 180,
            render: (e, ele) => (
                <Space size={8}>
                    <div style={{ textAlign: 'center' }}>
                        <Text type="secondary" style={{ fontSize: '11px', display: 'block' }}>Pendent</Text>
                        <Tag color={AvaluacioColors.colors.color3} style={{ margin: 0 }}>{ele.percentatge.percentA}%</Tag>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <Text type="secondary" style={{ fontSize: '11px', display: 'block' }}>NP</Text>
                        <Tag color={AvaluacioColors.colors.color5} style={{ margin: 0 }}>{ele.percentatge.percentNP}%</Tag>
                    </div>
                </Space>
            )
        },
        {
            title: 'Accions',
            key: 'actions',
            dataIndex: 'actions',
            width: 150,
            render: (e, ele) => {
                const now = dayjs().tz(TIMEZONE);
                const start = ele.data_ini ? dayjs(ele.data_ini) : null;
                const end = ele.data_fi ? dayjs(ele.data_fi) : null;
                const isAccessible = ele.percentatge?.estat === 1;

                return (
                    <Space>
                        {(user.tipus === "0" || user.tipus === "1") &&
                            <Tooltip title="Editar">
                                <Button
                                    type="text"
                                    icon={<BiPencil style={{ color: AvaluacioColors.colors.color4 }} />}
                                    onClick={() => editar(ele)}
                                />
                            </Tooltip>
                        }
                        {(user.tipus === "0" || user.tipus === "1") &&
                            <Tooltip title="Duplicar a una altra aula">
                                <Button
                                    type="text"
                                    icon={<BiCopy style={{ color: '#722ed1', fontSize: 17 }} />}
                                    onClick={() => duplicar(ele)}
                                />
                            </Tooltip>
                        }

                        {(() => {
                            if (user.tipus === "1" || user.tipus === "0") {
                                // Admins always access
                                return (
                                    <Tooltip title="Accedir">
                                        <Button
                                            type="primary"
                                            shape="circle"
                                            icon={<BiArrowFromLeft />}
                                            onClick={() => navegar(ele)}
                                            style={{ backgroundColor: AvaluacioColors.colors.color5 }}
                                        />
                                    </Tooltip>
                                )
                            } else {
                                // Students
                                if (isAccessible) {
                                    return (
                                        <Tooltip title="Accedir">
                                            <Button
                                                type="primary"
                                                shape="circle"
                                                icon={<BiArrowFromLeft />}
                                                onClick={() => navegar(ele)}
                                                style={{ backgroundColor: AvaluacioColors.colors.color5 }}
                                            />
                                        </Tooltip>
                                    )
                                } else {
                                    return (
                                        <Tooltip title="Visualitzar Notes">
                                            <Button
                                                shape="circle"
                                                icon={<BiShow style={{ color: 'white' }} />}
                                                onClick={() => viewNotes(ele)}
                                                style={{ backgroundColor: AvaluacioColors.colors.color3, border: 'none' }}
                                            />
                                        </Tooltip>
                                    )
                                }
                            }
                        })()}

                        {(user.tipus === "0" || user.tipus === "1") && ele.percentatge?.estat === 2 &&
                            <Tooltip title="Descarregar Informe PDF">
                                <Button
                                    type="text"
                                    icon={<BiSolidFilePdf style={{ color: AvaluacioColors.colors.color6, fontSize: '20px' }} />}
                                    onClick={() => download(ele)}
                                />
                            </Tooltip>
                        }
                    </Space>
                )
            },
        },
    ];

    function getColor(percentP: number, percentA: number, percentNP: number, threshold: number, colors: any): string {
        if (percentA > threshold) return yellow[6];
        if (percentNP > threshold) return red[3];
        if (percentP > threshold) return colors;
        return "gray";
    }

    const tableProps: TableProps<any> = {
        loading
    };

    function setPnt(value: number) {
        setPantalla(value);
    }

    function onClose(value: boolean) {
        if (value)
            checkDades();
        setModal(false);
        setLoading(false);
    }

    function nou() {
        setLoading(true);
        setModal(true);
        setSelected({ id: 0 });
    }

    if (isLoggedIn) {
        return (
            <>
                <AppSider setPantalla={setPnt} currentVal={1} />
                <Content style={{ padding: '24px', minHeight: 'calc(100vh - 64px)', backgroundColor: '#f0f2f5', overflow: 'auto' }}>
                    <div style={{ padding: '0 24px', maxWidth: 1600, margin: '0 auto' }}>
                        <br />
                        {/* Header Section */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: 24,
                            background: '#fff',
                            padding: '16px 24px',
                            borderRadius: 12,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                                <div style={{
                                    backgroundColor: AvaluacioColors.colors.color1,
                                    padding: 10,
                                    borderRadius: 10,
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <BiSolidGraduation size={24} />
                                </div>
                                <div>
                                    <Title level={2} style={{ margin: 0, fontSize: 24, fontWeight: 600, color: '#1f1f1f' }}>Projectes</Title>
                                    <Text type="secondary">Llistat de projectes d'aprenentatge actius</Text>
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: 12 }}>
                                {!loading && (
                                    <Button
                                        icon={<BiRefresh size={18} />}
                                        onClick={() => checkDades()}
                                        size="large"
                                    >
                                        Actualitzar
                                    </Button>
                                )}
                                {(user.tipus === "1" || user.tipus === "0") && !loading && (
                                    <Button
                                        type="primary"
                                        icon={<BiPlus size={18} />}
                                        onClick={() => nou()}
                                        size="large"
                                        style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                                    >
                                        Nou Projecte
                                    </Button>
                                )}
                            </div>
                        </div>

                        {/* Main Content */}
                        <Card
                            bordered={false}
                            className="shadow-sm"
                            style={{ borderRadius: 12, overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}
                            bodyStyle={{ padding: 0 }}
                        >
                            <Table
                                size={"middle"}
                                {...tableProps}
                                bordered={false}
                                columns={columns}
                                dataSource={percentatges}
                                rowClassName="editable-row"
                                onChange={(pagination, filters, sorter) => {
                                    if (filters.estat) {
                                        setFilteredEstat(filters.estat);
                                    } else {
                                        setFilteredEstat([]);
                                    }
                                }}
                                pagination={{ pageSize: 10, showSizeChanger: true }}
                            />
                        </Card>
                    </div>
                </Content>

                {modal && <ProjecteModal element={selected} visible={modal} onClose={onClose} />}

                {duplicarModal && selectedForDuplicate && (
                    <ProjecteDuplicarModal
                        projecte={selectedForDuplicate}
                        visible={duplicarModal}
                        onClose={(reload) => {
                            setDuplicarModal(false);
                            if (reload) checkDades();
                        }}
                    />
                )}

                {notesModalVisible && notesData && (
                    <AntModal
                        title={`Notes: ${notesData.project.nom}`}
                        open={notesModalVisible}
                        onCancel={() => setNotesModalVisible(false)}
                        width={1200}
                        footer={null}
                        destroyOnClose
                        style={{ top: 20 }}
                        bodyStyle={{ padding: '24px' }}
                    >
                        <Spin spinning={loadingNotes}>
                            <div style={{ marginBottom: 24, padding: '16px', backgroundColor: '#fafafa', borderRadius: 8, border: '1px solid #f0f0f0' }}>
                                <span style={{ marginRight: 12, fontWeight: 500 }}>Selecciona un Sprint:</span>
                                <Select
                                    style={{ width: 250 }}
                                    value={selectedSprint?.id}
                                    onChange={(val) => {
                                        const sp = notesData.project.sprints?.find((s: any) => s.id === val);
                                        setSelectedSprint(sp);
                                    }}
                                    options={notesData.project.sprints?.map((s: any) => ({ label: s.label, value: s.id }))}
                                />
                            </div>

                            {selectedSprint && (
                                <ProjecteIdTasques
                                    idProjecte={notesData.project.id}
                                    idGrup={notesData.group}
                                    sprint={selectedSprint}
                                    readOnly={true}
                                />
                            )}
                        </Spin>
                    </AntModal>
                )}
            </>
        );
    } else {
        return (
            <Login />
        );
    }
};

export default Projectes;
